import { Component, h } from 'preact';
import linkState from 'linkstate';
import { Subject, Subscription, fromEvent, interval } from 'rxjs';
import { distinctUntilChanged, map, debounce, filter, tap } from 'rxjs/operators';
import { distinctUntilChangedImmutable } from 'distinct-until-changed-immutable';

import getStore, { appState$ } from '../../../store';
import * as InquiriesActions from '../../../reducers/inquiries/inquiries.actions';

import { InquiryGridFilters } from './inquiry-grid-filters.component';
import { InquiryPipelineFiltersUiModel, InquiryStageDefinition } from '../../../../../types/inquiries';
import { INQUIRY_PAGE_STAGES } from '../../../../../constants/inquiries';
import { HopplerModalizer } from '../../common/hoppler-modalizer.component';


interface InquiryGridFiltersHostProps {
  active?: boolean;
  useModal?: boolean;
  stageSlug: string;

  onApply?: (filters: InquiryPipelineFiltersUiModel) => void;
}

interface InquiryGridFiltersHostState {
  filters?: InquiryPipelineFiltersUiModel,
  filterCardVisible?: boolean;
};

const store = getStore();

export class InquiryGridFiltersHost extends Component<InquiryGridFiltersHostProps, InquiryGridFiltersHostState> {
  subscriptions: Subscription[] = [];

  componentDidMount() {
    const inquiries$ = appState$.pipe( map(s => s.inquiries) );
    this.subscriptions.push(
      inquiries$.pipe(
        map(inquiries => inquiries.filters),
        distinctUntilChangedImmutable()
      ).subscribe(filters => this.setState({ filters }))
    );

    this.subscriptions.push(
      inquiries$.pipe(
        map(inquiries => inquiries.filterCardVisible),
        distinctUntilChanged()
      ).subscribe(filterCardVisible => this.setState({ filterCardVisible }))
    );
  }

  onApply(filters: InquiryPipelineFiltersUiModel) {
    // console.log('APPLY!', filters);
    this.props.onApply(filters);
  }

  onClose() {
    store.dispatch(InquiriesActions.setFilterVisibility(false));
  }

  render(props: InquiryGridFiltersHostProps, state: InquiryGridFiltersHostState) {
    const currentStage = INQUIRY_PAGE_STAGES.find(stage => stage.slug === props.stageSlug);

    const card = (
      <InquiryGridFilters
        onChange={ linkState(this, 'filters') }
        onApply={ filters => this.onApply(filters) }
        filters={ state.filters }
        onClose={ () => this.onClose() }
        currentStage={ currentStage } />
    );
    
    if (props.active && state.filterCardVisible) {
      if (props.useModal) {
        return (
          <HopplerModalizer onClose={ () => null }>
            { card }
          </HopplerModalizer>
        )
      } else {
        return card;
      } 
    }
  }

  componentWillUnmount() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}
